module.exports = __webpack_public_path__ + "static/img/academic4.3be85fbe.png";